export const ASSET_DOCUMENT_WRITE_RIGHTS = [
  'W_RequestAssetDrivingAbroad',
  'W_RequestAssetDamageDelegacy',
  'W_RequestAssetOther',
  'W_RequestAssetVignette',
];

export const CONTRACT_MODIFICATIONS_WRITE_RIGHTS = [
  'W_RequestContractModificationReimbursement',
  'W_RequestContractModificationInstallmentDeferral',
  'W_RequestContractModificationOther',
];

export const CLIENT_DATA_WRITE_RIGHTS = [
  'W_RequestClientDataAddress',
  'W_RequestClientDataContactInformation',
  'W_RequestClientDataBeneficialOwner',
  'W_RequestClientDataAssociate',
  'W_RequestClientDataCompanyInformation',
  'W_RequestClientDataLegalRepresentative',
  'W_RequestClientDataPersonalInformation',
  'W_RequestClientDataOther',
];
